import React, { FC } from 'react';

import { IconPropsExtended } from '../types';

import MaterialSymbolIconBase from './MaterialSymbolIconBase';

/**
 * Material symbol error icon
 *
 * @param props Props passed to the component
 * @returns     Error icon
 */
const MaterialSymbolErrorIcon: FC<IconPropsExtended> = props => (
  <MaterialSymbolIconBase {...props} iconName="error" />
);

export default MaterialSymbolErrorIcon;
